import { h } from 'preact';
import * as BaseComp from 'components/shared/articleThumb/articleThumb.js';
import s from 'components/shared/articleThumb/articleThumb.sss';
import Store from 'store/store';
import * as actions from 'store/actions';

import { Link } from 'components/core/link/link.js';
import HTML from 'components/core/html/html';

export default class ArticleThumb extends BaseComp.default {

	getExtraBodyContent() {
		return (
			<div class={s.buttons}>
				{this.props.data.trailerBtn && <Link
					class={s.trailer}
					href={this.props.data.trailerBtn.href}
					title={this.props.data.trailerBtn.title}
					extraOnClick={() => Store.emit(actions.POWSTER_GA_EVENT_TRACK, 'programme-click', 'our-pogramme', this.props.data.title + '_Watch Trailer')}
				>
					Watch Trailer
				</Link>}
				<Link
					class={s.tickets}
					pageId='showtimes'
					queryString={`title=${this.props.data.title}`}
					title={this.props.data.linkTitle}
					extraOnClick={() => Store.emit(actions.POWSTER_GA_EVENT_TRACK, 'programme-click', 'our-pogramme', this.props.data.title + '_Buy Tickets')}
				>
					Buy tickets <img src="https://s3-eu-west-1.amazonaws.com/st-static-stage/nationaltheatrelive/national-theatre-live-venue-finder/images/arrow.png" alt="arrow pointing up right" />
				</Link>
			</div>
		);
	}

	renderBodyImage() {
		let data = this.props.data;
		let img = <img class={this.s.bodyImage} src={data.imageSrc} alt={data.imageAlt} />;
		if (data.imageLink) {
			img = (
				<Link class={this.s.imageLink} href={data.imageLink} target="_blank">
					<img class={this.s.bodyImage} src={data.imageSrc} alt={data.imageAlt}/>
				</Link>
			);
		} else {
			img = (
				<div class={this.s.imageLink}>
					<img class={this.s.bodyImage} src={data.imageSrc} alt={data.imageAlt}/>
				</div>
			);
		}
		return img;
	}

	render(props) {
		const {
			data,
			copy,
			thumbClass
		} = props;

		if (!data) return;
		let readMore = '';
		let body = copy[data.body] || data.body || '';
		let img = data.imageSrc;
		const breakAmount = data.breakAmount || 700;
		const readMoreText = copy.$READ_MORE || 'Read More';
		const readLessText = copy.$READ_LESS || 'Read Less';
		if (body && body.length > breakAmount && !data.hideReadMore) {
			readMore = <Link class={this.s.readMore} extraOnClick={this.toggleFullBody} renderCustomChild>{this.state.fullBody ? readLessText : readMoreText}</Link>;

			if (!this.state.fullBody) {
				const shortBody =  body.substr(0, breakAmount);
				body = shortBody.substr(0, Math.min(shortBody.length, shortBody.lastIndexOf(' '))) + '...';
			}
		}

		let readMoreCta = copy[data.readMoreCta] || data.readMoreCta || 'Read More';
		return (
			<Link class={thumbClass} href={data.readMoreLink || data.link} pageId={data.pageId ? data.pageId : false} target="_blank" trackId={data.trackId}>
				<div class={this.s.container}>
					{data.imageSrc && <img class={this.s.image} src={data.imageSrc} />}
					<div class={this.s.textWrap}>
						{data.publication && <p class={this.s.publication}>{data.publication}</p>}
						{data.title && <HTML class={this.s.articleTitle} content={data.title} markdown tag="h2" />}
						{this.getExtraContent()}
						{data.subtitle && <h3 class={this.s.articleSubtitle}>{data.subtitle}</h3>}
						<p class={this.s.body}>
							{this.renderBodyImage()}
							{body && <div class={this.s.content}>
								<HTML content={body} markdown />
								{this.getExtraBodyContent()}
							</div>}
							{data.author && <p class={this.s.author}>{data.author}</p>}

						</p>
						{readMore}
						{data.readMoreLink && <Link href={data.readMoreLink} class={this.s.readMore} target='_blank' renderCustomChild>{readMoreCta}</Link>}
						{data.pathLink && <Link class={this.s.readMorePath} pageId={data.pathLink}>{readMoreCta}</Link>}
						<span class={this.s.date}>{data.date}</span>
						{this.getExtraContentBottom()}
					</div>
				</div>
			</Link>
		);
	}

}
